import React from "react";

export const Section = (props) => {
    return <h4 style={{padding: '10px 0', borderBottom: '2px solid #f5f5f5'}}>
        {props.children}
    </h4>
};